import { lazy } from 'react';

import { renderRoutesFromArray } from './renderRoutesFromArray';

const PaymentMethod = lazy(() => import('../screens/main/subscriptions/components/payment-method'));
const PaymentMethodDetails = lazy(
  () => import('../screens/main/subscriptions/pages/payment-method-details')
);
const PaymentMethodUpdate = lazy(
  () => import('../screens/main/subscriptions/pages/change-payment-method')
);
const Subscription = lazy(() => import('@/screens/main/subscriptions/pages/subscription'));
const SubscriptionCheckout = lazy(
  () => import('../screens/main/subscriptions/pages/subscription-checkout')
);
const SubscriptionComplete = lazy(
  () => import('@/screens/main/subscriptions/pages/subscription-complete')
);
const SubscriptionUpdate = lazy(
  () => import('../screens/main/subscriptions/pages/subscription-update')
);
const SubscriptionSuccess = lazy(
  () => import('../screens/main/subscriptions/pages/subscription-success')
);

const routeDefinitions = [
  {
    path: '/my-profile/payment-method',
    element: <PaymentMethod />,
  },
  {
    path: '/my-profile/payment-method/details',
    element: <PaymentMethodDetails />,
  },
  {
    path: '/my-profile/payment-method/update',
    element: <PaymentMethodUpdate />,
  },
  {
    path: '/subscription',
    element: <Subscription />,
  },
  {
    path: '/subscription/checkout',
    element: <SubscriptionCheckout />,
  },
  {
    path: '/subscription/complete',
    element: <SubscriptionComplete />,
  },
  {
    path: '/subscription/update',
    element: <SubscriptionUpdate />,
  },
  {
    path: '/subscription/success',
    element: <SubscriptionSuccess />,
  },
];

const subscriptionRoutes = renderRoutesFromArray(routeDefinitions);
export default subscriptionRoutes;
